// extracted by mini-css-extract-plugin
export default {"spoilersWrapper":"Spoilers_spoilersWrapper__bMosJ","spoilers":"Spoilers_spoilers__ELXih","hover":"Spoilers_hover__lqc+Q","spoilersBody":"Spoilers_spoilersBody__OM7Ew"};